import React, {Component} from 'react';
import {observer, inject} from 'mobx-react';

import {getLogoSrc} from "../../utils/Utils";

@inject("appStore")
@observer
class EndLanding extends Component {
    componentDidMount() {
        this.props.appStore.tracking.pageview('End');
    }

    createMarkup = (string) => {
        return {__html: string};
    };
    render() {
        const appStoreColor = this.props.appStore.appConfig.content.brand.brandColor;
        const textColor = this.props.appStore.appConfig.content.brand.textColor;
        const style = {
            backgroundColor: `rgba(${ appStoreColor.r }, ${ appStoreColor.g }, ${ appStoreColor.b }, ${ appStoreColor.a })`,
            color: `rgba(${textColor.r}, ${textColor.g}, ${textColor.b}, ${textColor.a})`,
        };
        return (
            <div className={(this.props.appStore.isMobile) ? "EndLanding mobile" : "EndLanding desktop"} style={style}>
                <div className="container" style={style}>
                    {this.props.appStore.appConfig.content.thankyou.displayLogo &&
                     this.props.appStore.appConfig.content.brand.logo &&
                    <div className="logo">
                        <img alt="Logo" src={getLogoSrc(this.props.appStore.appConfig.content.brand.logo)}/>
                    </div>}
                    <div className="content">
                        <h2 className="header">{this.props.appStore.appConfig.content.thankyou.headline}</h2>
                        <div className="copy">
                            <div dangerouslySetInnerHTML={this.createMarkup(this.props.appStore.appConfig.content.thankyou.text)}/>
                        </div>
                    </div>
                    {this.props.appStore.appConfig.content.thankyou.link &&
                    <a href={this.props.appStore.thankYouLink}
                       className="take-again">
                        {this.props.appStore.appConfig.content.thankyou.label}
                    </a>}
                </div>
            </div>
        );
    }
}

export default EndLanding;



// WEBPACK FOOTER //
// ./src/scenes/EndLanding/index.js